import React, { useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

export type TakeoffOnboardingMode = 'full' | 'power' | 'lighting';

interface TakeoffOnboardingStartModalProps {
  show: boolean;
  onSelectMode: (mode: TakeoffOnboardingMode) => void;
}

export const TakeoffOnboardingStartModal: React.FC<TakeoffOnboardingStartModalProps> = ({
  show,
  onSelectMode,
}) => {
  const [isFullHover, setIsFullHover] = useState(false);
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const fullBtnBg = isDark
    ? (isFullHover ? '#ffffff' : 'transparent')
    : (isFullHover ? '#111111' : '#ffffff');
  const fullBtnColor = isDark
    ? (isFullHover ? '#111111' : '#ffffff')
    : (isFullHover ? '#ffffff' : '#111111');

  const fullTakeoffLogoSrc = isDark
    ? (isFullHover ? '/output-onlinepngtools.png' : '/bidflowlogo-removebg-preview.png')
    : (isFullHover ? '/bidflowlogo-removebg-preview.png' : '/output-onlinepngtools.png');
  const fullBtnGlow = isFullHover
    ? '0 0 16px rgba(37, 99, 235, 0.52), 6px -3px 34px rgba(59, 130, 246, 0.38), -7px 5px 46px rgba(96, 165, 250, 0.26)'
    : '0 0 12px rgba(37, 99, 235, 0.40), 4px -2px 24px rgba(59, 130, 246, 0.28), -5px 3px 34px rgba(96, 165, 250, 0.20)';
  const fullBtnAnimation = isFullHover
    ? 'takeoffBlueWarpGlow 1.9s ease-in-out infinite'
    : 'takeoffBlueWarpGlow 2.6s ease-in-out infinite';

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.55)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100020,
        padding: '28px',
      }}
    >
      <style>{`
        @keyframes takeoffBlueWarpGlow {
          0% {
            box-shadow:
              0 0 14px rgba(37, 99, 235, 0.48),
              5px -2px 30px rgba(59, 130, 246, 0.34),
              -6px 4px 42px rgba(96, 165, 250, 0.24);
          }
          33% {
            box-shadow:
              -4px 3px 17px rgba(37, 99, 235, 0.56),
              8px 4px 36px rgba(59, 130, 246, 0.38),
              -10px -3px 52px rgba(96, 165, 250, 0.27);
          }
          66% {
            box-shadow:
              6px 4px 18px rgba(37, 99, 235, 0.52),
              -5px -3px 32px rgba(59, 130, 246, 0.36),
              9px -5px 48px rgba(96, 165, 250, 0.25);
          }
          100% {
            box-shadow:
              0 0 14px rgba(37, 99, 235, 0.48),
              5px -2px 30px rgba(59, 130, 246, 0.34),
              -6px 4px 42px rgba(96, 165, 250, 0.24);
          }
        }
      `}</style>
      <div
        style={{
          width: '100%',
          maxWidth: '620px',
          background: 'var(--bg-primary)',
          border: '1px solid var(--border-color)',
          borderRadius: '18px',
          boxShadow: '0 24px 64px rgba(0, 0, 0, 0.35)',
          padding: '34px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          position: 'relative',
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '26px', color: 'var(--text-primary)' }}>
              Start Your Takeoff
            </h3>
            <p style={{ margin: '10px 0 0', color: 'var(--text-muted)', fontSize: '15px', lineHeight: 1.5 }}>
              Click the button below to start your takeoff. We will guide you step-by-step.
            </p>
            {/* <p style={{ margin: '8px 0 0', color: 'var(--text-secondary)', fontSize: '13px', lineHeight: 1.4 }}>
              Choose one option to continue.
            </p> */}
          </div>
        </div>

        <div style={{ width: '100%', display: 'grid', gap: '12px', marginTop: '16px' }}>
          <button
            onClick={() => onSelectMode('full')}
            onMouseEnter={() => setIsFullHover(true)}
            onMouseLeave={() => setIsFullHover(false)}
            style={{
              width: '100%',
              border: 'none',
              background: fullBtnBg,
              color: fullBtnColor,
              borderRadius: '16px',
              padding: '22px 28px',
              cursor: 'pointer',
              fontWeight: 800,
              fontSize: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '14px',
              transition: 'background 0.2s ease, color 0.2s ease, box-shadow 0.25s ease',
              boxShadow: fullBtnGlow,
              animation: fullBtnAnimation,
              willChange: 'box-shadow',
            }}
          >
            <img
              src={fullTakeoffLogoSrc}
              alt="BidFlow"
              style={{
                width: '30px',
                height: '30px',
                objectFit: 'contain',
                flexShrink: 0,
              }}
            />
            Start Takeoff
          </button>

          {/* <div style={{ border: '1px solid var(--border-color)', borderRadius: '14px', overflow: 'hidden' }}>
            <button
              onClick={() => onSelectMode('power')}
              className="count-all-power-btn"
              style={{
                minHeight: '58px',
                fontSize: '15px',
              }}
            >
              <Zap size={16} />
              <span>Power Detection</span>
            </button>
          </div> */}

          {/* <div style={{ border: '1px solid var(--border-color)', borderRadius: '14px', overflow: 'hidden' }}>
            <button
              onClick={() => onSelectMode('lighting')}
              className="count-all-lighting-btn"
              style={{
                minHeight: '58px',
                fontSize: '15px',
              }}
            >
              <Lightbulb size={16} />
              <span>Auto Lighting</span>
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
